// scroll.js
// Provides shared helpers for scrolling interactions within the single-page experience.

/**
 * scrollToSection
 * Smoothly scrolls to the element that matches the provided id.
 */
export function scrollToSection(event, targetId, options) {
  if (event) {
    event.preventDefault();
  }

  if (!targetId) {
    return;
  }

  const targetElement = document.getElementById(targetId);
  if (!targetElement) {
    return;
  }

  const scrollOptions = options ?? { behavior: 'smooth', block: 'start' };
  targetElement.scrollIntoView(scrollOptions);
}
